var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _rect, _rect2, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 80,
    x2: 104,
    y2: 80,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 80,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 80,
    x2: 40,
    y2: 84,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 80,
    x2: 64,
    y2: 84,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 80,
    x2: 88,
    y2: 84,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 56,
    x2: 16,
    y2: 56,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 36,
    x2: 16,
    y2: 36,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 16,
    y2: 20,
    stroke: "#C7D1CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 78 C24 78 30 72 36 60 C44 44 52 28 60 20 C68 14 76 13 88 13",
    stroke: "#A7B7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 87,
    width: 20,
    height: 5,
    rx: 2,
    fill: "#E0E6E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 44,
    width: 5,
    height: 20,
    rx: 2,
    fill: "#E0E6E3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 68,
    r: 2.5,
    fill: "#C7D1CC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 52,
    r: 2.5,
    fill: "#C7D1CC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 32,
    r: 2.5,
    fill: "#C7D1CC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 18,
    r: 2.5,
    fill: "#C7D1CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChart);
export default __webpack_public_path__ + "static/media/empty-chart.7e1cee56c6524befcabd6ecccc58dea1.svg";
export { ForwardRef as ReactComponent };